export default "__VITE_ASSET__BxwRotHM__"